module.exports = __webpack_public_path__ + "img/image12-3.ba3c0775.png";